import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import '../../App.css';
import { useDispatch } from 'react-redux';
import '../../Dashboard.css';
import {brands, setLoading, statuses} from '../../services/reducers/homeSlice';
import { address, cart, favorites, fetchProfile, orders, profile } from '../../services/reducers/userSlice';
import restApi from '../../services/restApi';
import { useAppSelector } from '../../services/store';

function App() {
  const dispatch: any = useDispatch();

  const initialize = async () => {
    if (window.location.href.toLowerCase().includes('/invitation')) {
      // Public page, no auth required — skip the login gate entirely.
      return;
    }

    if(!Cookies.get('token') && !window.location.href.includes('login')){
      window.location.href = '/login';
    }
    else{
      dispatch(setLoading(true));

      const res = await restApi(process.env.REACT_APP_BASE_URL + '/user', true).get();

      if (res.code == 200){
        // Non-super-admin roles (FELTBOWLCOMMERCE, BEARINGCOMMERCE, WAREHOUSE)
        // only ever get an /order sidebar link, but that only hides other
        // links — it doesn't stop someone from typing another admin URL
        // directly. Enforce it here too, not just in the sidebar.
        if (res.data.role !== "SUPER_ADMIN" && !window.location.href.toLowerCase().includes('/order')){
          window.location.href = '/order' ;
        }
      }else if(res.code == 401){
        Cookies.remove('token')
      }

      dispatch(profile(res.data));

      dispatch(cart());
      dispatch(statuses());
      dispatch(orders());
      dispatch(favorites());
      dispatch(address());
      dispatch(brands())


      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <></>
  );
}

export default App;
